import React, { useState, useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { connect } from 'react-redux';
import {
    Button,
    makeStyles,
    withStyles,
    Card,
    CardHeader,
    CardContent,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Dialog,
    DialogContent,
    DialogActions,
    Paper,
    Typography,
    Box
} from '@material-ui/core';
import {
    updateChatView
} from "../../../store/actions/userActionCreators";
import * as logger from "../../../logger";
import {
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineDot,
    TimelineConnector,
    TimelineContent
} from '@material-ui/lab';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import { numberFormat } from '../../../utils/utils';
import RoundedGreenTickIcon from '../../../assets/rounded-green-tick.svg';
import BankIcon from '../../../assets/bank-icon-white.svg';
import BankIconOrange from '../../../assets/bank-icon-orange.svg';
import ErrorIconRed from '../../../assets/transaction-error-icon-red.svg';
import ErrorIconWhite from '../../../assets/transaction-error-icon-white.svg';
import PendingIconWhite from '../../../assets/transaction-pending-icon-white.svg';
import PendingIconOrange from '../../../assets/transaction-pending-icon-orange.svg';
import RefundSuccessWhite from '../../../assets/refund-successful-white-icon.svg';
import RefundPendingOrange from '../../../assets/refund-pending-orange-icon.svg';
import RefundSuccessGreen from '../../../assets/refund-successful-green.svg';
import RefundFailedIcon from '../../../assets/refund-failed-red.svg';
import { getMilliDateInDayDateTime } from '../../../utils/utils';
import { EditFastagExpense,getFastTagRechargeStatus } from '../../../store/actions/fastagActionCreators';
import { getDateInStringDDMMMYYYY } from '../../../utils/utils';
import UPI from '../Payment/upi.png';
import TransportPayWallet from '../Payment/TransportPayWallet.svg';
import CreditCard from '../Payment/credit-card.png';
import NetBanking from '../Payment/NetBanking.svg';
import {
    Checkboxes
  } from 'mui-rff';
  import Checkbox from '@material-ui/core/Checkbox';

const GreenCheckbox = withStyles({
root: {
    color: '#c7c7c7',
    '&$checked': {
        color: '#00875a',
    },
},
checked: {},
})((props) => <Checkbox color="default" {...props} />);
const useStyles = makeStyles(theme => ({
    transactionDetailsDrawer: {
        width: 474,
        maxWidth: 474,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        }
    },
    divTitle: {
        display: 'flex',
        alignItems: 'center',
        color: "#0b1323",
        fontSize: 18,
        marginBottom: 4,
        fontWeight: 600,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal'
    },
    helpButton: {
        border: '1px solid #00885a',
        color: '#00885a',
        fontSize: 14,
        textTransform: 'none',
        borderRadius: 6,
        fontWeight: 600,
        marginRight: 20
    },
    divAlign: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    divHeaderTitle: {
        fontSize: 16,
        fontWeight: 600,
        color: '#0b1323'
    },
    rechargeButton: {
        borderRadius: 4,
        backgroundColor: '#161f34',
        fontWeight: 300,
        textTransform: 'none',
        color: 'white',
        marginLeft: 12,
        '&:hover': {
            backgroundColor: '#161f34'
        }
    },
    closeButton: {
        padding: '6px 20px',
        borderRadius: '4px',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)'
        }
    },
    titleV1: {
        fontSize: 12,
        fontWeight: 600,
        color: 'rgba(11, 19, 35, 0.75)',
        textAlign: 'left'
    },
    titleV2: {
        fontSize: 12,
        fontWeight: 600,
        textAlign: 'right',
        color: 'rgba(11, 19, 35, 0.75)'
    },
    textV1: {
        fontSize: '16px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        marginTop: 2
    },
    textV2: {
        fontSize: '16px',
        fontWeight: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323',
        marginTop: 2
    },
    textV4: {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323',
        marginTop: 2
    },
    textLoss: {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#e61b1b',
        marginTop: 2
    },
    textV3: {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323',
        marginTop: 2,
        display: 'flex'
    },
    mlV1: {
        marginLeft: 6
    },
    mtV1: {
        marginTop: 16
    },
    cardV1: {
        borderRadius: '8px !important',
        width: '100%',
        boxShadow: 'none !important'
    },
    dialogTitleV1: {
        paddingBottom: '12px !important',
        '& .MuiTypography-root': {
            width: '100%',
        }
    },
    sideBarDialogContentV1: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 32,
        paddingBottom: '32px !important',
        backgroundColor: '#f6f6f8'
    },
    cardHeaderRoot: {
        paddingTop: 12,
        paddingBottom: '12px !important',
        paddingLeft: 16,
        paddingRight: 16
    },
    rechargeSuccessHeader: {
        backgroundColor: '#e1fce6'
    },
    rechargePendingHeader: {
        backgroundColor: '#fee6b9'
    },
    rechargeFailedHeader: {
        backgroundColor: '#f8cece'
    },
    cardAvatar: {
        marginRight: 8
    },
    cardV2: {
        borderRadius: '8px !important',
        width: '100%',
        boxShadow: 'none !important',
        marginTop: 24,
        padding: '24px !important',
        // minHeight: '208px !important'
    },
    cardV3: {
        borderRadius: '8px !important',
        width: '100%',
        boxShadow: 'none !important',
        marginTop: 24,
        padding: '24px !important',
        minHeight: '208px !important'
    },
    missingOppositeContentV1: {
        '&:before': {
            flex: 'inherit',
            content: 'none',
            padding: '0px !important'
        }
    },
    rootDotPending: {
        width: '32px',
        height: '32px',
        padding: '0px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0px !important',
        fontSize: 22,
        backgroundColor: '#FC6F08',
        boxShadow: 'none !important'
    },
    rootDotSuccessful: {
        width: '32px',
        height: '32px',
        padding: '0px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0px !important',
        fontSize: 18,
        backgroundColor: '#24ad31',
        boxShadow: 'none !important'
    },
    rootDotFailed: {
        width: '32px',
        height: '32px',
        padding: '0px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0px !important',
        fontSize: 22,
        backgroundColor: '#e61b1b',
        boxShadow: 'none !important'
    },
    rootDotFailedV1: {
        width: '32px',
        height: '32px',
        padding: '0px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0px !important',
        fontSize: 22,
        backgroundColor: '#f8cece',
        boxShadow: 'none !important'
    },
    rootDotSuccessfulV1: {
        width: '32px',
        height: '32px',
        padding: '0px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0px !important',
        fontSize: 22,
        backgroundColor: '#24ad31',
        boxShadow: 'none !important'
    },
    rootDotPendingV1: {
        width: '32px',
        height: '32px',
        padding: '0px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0px !important',
        fontSize: 22,
        backgroundColor: '#fee6b9',
        boxShadow: 'none !important'
    },
    lineConnectorRoot: {
        minHeight: 48,
        backgroundColor: '#24ad31'
    },
    lineConnectorPending: {
        minHeight: 48,
        backgroundColor: '#e4e4e4'
    },
    contentRootV1: {
        paddingLeft: 12,
        paddingRight: 12,
        paddingBottom: '0px !important',
        paddingTop: '0px !important',
        marginTop: '-4px',
        height: 'fit-content'
    },
    titleV5: {
        fontSize: 16,
        fontWeight: 600,
        textAlign: 'left',
        color: '#0b1323'
    },
    textV5: {
        fontSize: 12,
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#0b1323'
    },
    textV6: {
        fontSize: 12,
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        width: 210
    },
    timeLineV1: {
        padding: '0px !important',
        margin: '0px !important'
    },
    imgV1: {
        height: '20px !important',
        width: '20px !important'
    },
    timeLineItemRoot: {
        minHeight: 'fit-content'
    },
    imgV2: {
        width: 32,
        height: 32
    },
    saveAsExpense:{
            marginBottom:0,
            marginTop:12
    },
    red:{
        fontWeight:'bold',
        color:'red'
    },
    blue:{
        fontWeight:'bold',
        color:'#0033cc'
    },
    paymentToCard: {
        boxShadow:'none',
        borderRadius:8,
        marginTop:16
    },
    detailsDiv:{
        padding:16
    },
    section:{
        marginBottom:16,
        display:'flex',
        flexDirection:'column',
        "&:last-child": {
          marginBottom: 0
        }
    },
    subTitleSec:{
        marginBottom:2,
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
        alignItems:'center'
    },
    valueSec:{
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
        alignItems:'center'
    },
    subTitleTxt:{
        fontSize:12,
        fontWeight:500,
        color: "rgba(11, 19, 35, 0.5)"
    },
    headerTxt:{
        fontSize:16,
        fontWeight:600,
        color:"#0b1323"
    },
    modeValueTxt:{
      fontSize:14,
      marginLeft:16
    },
    paymentModeUsedCard: {
        boxShadow:'none',
        borderRadius:8,
        marginTop:16
    },
    amount:{
      fontWeight:600,
      color:'#000',
      fontSize:14,
      textAlign:'right'
    }
}));

const FastTagTransactDetailsSideBar = ({
    rightSideBarOpen,
    toggleRightSideBar,
    dispatchChatView,
    dispatchEditFastagExpense,
    dispatchGetFastTagRechargeStatus,
    fastag,
    rechargeAgain
}) => {

    const [fastTagRechargeInfo, setFastTagRechargeInfo] = useState({});
    const [fastTagStatus, setFastTagStatus] = useState("");
    const [headerType, setHeaderType] = useState("");
    const [confirmDialog,setConfirmDialog] = useState(false)
    const classes = useStyles();

    const getPaymentMode = (type)=>{
        switch (type) {
            case "CREDIT_CARD":
                return <img src={CreditCard} width={24} height={24} />
            case "UPI":
                    return <img src={UPI} width={24} height={24} />
            case "PhonePe":
                return <img src={UPI} width={24} height={24} />
            case "WALLET":
                return <img src={TransportPayWallet} width={24} height={24} />
            case "NET_BANKING":
                return <img src={NetBanking} width={24} height={24} />
            default:
                return ""
        }
      }

    useEffect(() => {

        dispatchChatView(false);

    }, [rightSideBarOpen]);

    useEffect(() => {

        if (fastag && fastag.fastTagRechargeStatus) {
            setFastTagRechargeInfo(fastag.fastTagRechargeStatus);

            const rechargeStatusData = fastag.fastTagRechargeStatus;

            if (rechargeStatusData) {

                if ((rechargeStatusData.paymentStatus).toLowerCase() != "success") {

                    setHeaderType("transfer");
                    if ((rechargeStatusData.paymentStatus).toLowerCase() == "pending") {
                        setFastTagStatus('transfer_pending');
                    } else if ((rechargeStatusData.paymentStatus).toLowerCase() == "failed" || (rechargeStatusData.paymentStatus).toLowerCase() == "user_dropped") {
                        setFastTagStatus('transfer_failed');
                    }

                } else {

                    if (rechargeStatusData.refundStatus != null) {

                        setHeaderType("refund");
                        if ((rechargeStatusData.paymentStatus).toLowerCase() == "success" && (rechargeStatusData.refundStatus).toLowerCase() == "success") {
                            setFastTagStatus("refund_successful");
                        } else {
                            setFastTagStatus("refund_initiated");
                        }

                    } else if (rechargeStatusData.rechargeStatus != null) {

                        setHeaderType("recharge");
                        if ((rechargeStatusData.paymentStatus).toLowerCase() == "success" && (rechargeStatusData.rechargeStatus).toLowerCase() == "success") {
                            setFastTagStatus("recharge_successful");
                        } else {
                            setFastTagStatus("recharge_pending");
                        }

                    }

                }
            }
        }

    }, [fastag.fastTagRechargeStatus]);

    const handleClose = () => {
        dispatchChatView(true);
        toggleRightSideBar();
        fastag.fastTagRechargeStatus = {}
    }
    const fetchData = ()=>{
        dispatchGetFastTagRechargeStatus(fastTagRechargeInfo && fastTagRechargeInfo.id ? fastTagRechargeInfo.id : "",
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                      
                    }
                },
                () => {
                }
            )
    }
    const handleRechargeAgain = (e) => {
        rechargeAgain(e, { amount: fastTagRechargeInfo && fastTagRechargeInfo.rechargeAmount ? fastTagRechargeInfo.rechargeAmount : 0 })
    }
    const handleConfirmDialogClose = ()=>{
        fetchData()
        setConfirmDialog(false)
    }
    const onConfirm = ()=>{
        let req ={};
        if(fastTagRechargeInfo && fastTagRechargeInfo.saveAsExpense){
            req.operation = "REMOVE"
        }else{
            req.operation = "ADD"
        }
        dispatchEditFastagExpense(fastTagRechargeInfo && fastTagRechargeInfo.id ? fastTagRechargeInfo.id : "",req,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    fetchData()
                    setConfirmDialog(false) 
                }
            },
            () => {
            }
        )
    }
    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={rightSideBarOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >

                <SideBarDialogTitle id={"right-sidebar-for-Fast-Tag-Transact"} siderBarType={'truckBook'} onClose={handleClose} className={classes.dialogTitleV1}>
                    <div className={classes.divAlign}>
                        <div className={classes.divTitle}>
                            Recharge Details
                        </div>
                        {/* <Button variant="outlined" className={classes.helpButton}>
                            Help
                        </Button> */}
                    </div>
                </SideBarDialogTitle>



                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >

                    {/* ************************************** Transaction Information Card ************************************** */}
                    <Card className={classes.cardV1}>

                        {/* ************************************** Transaction Card Header ************************************** */}
                        {headerType == "recharge" &&
                            <CardHeader
                                avatar={
                                    <>
                                        {fastTagStatus == "recharge_successful" &&
                                            <img src={RoundedGreenTickIcon} className={classes.imgV2} />
                                        }
                                        {fastTagStatus == "recharge_pending" &&
                                            <img src={BankIconOrange} className={classes.imgV2} />
                                        }
                                    </>
                                }

                                title={
                                    <div className={classes.divHeaderTitle}>
                                        {fastTagStatus == "recharge_successful" &&
                                            <>
                                                Recharge Successful
                                            </>
                                        }
                                        {fastTagStatus == "recharge_pending" &&
                                            <>
                                                Recharge Pending
                                            </>
                                        }
                                    </div>
                                }
                                classes={{ root: classes.cardHeaderRoot, avatar: classes.cardAvatar }}
                                className={fastTagStatus == "recharge_successful" ? classes.rechargeSuccessHeader : classes.rechargePendingHeader}
                            />
                        }

                        {headerType == "transfer" &&
                            <CardHeader
                                avatar={
                                    <>
                                        {fastTagStatus == "transfer_failed" &&
                                            <img src={ErrorIconRed} className={classes.imgV2} />
                                        }
                                        {fastTagStatus == "transfer_pending" &&
                                            <img src={PendingIconOrange} className={classes.imgV2} />
                                        }
                                    </>
                                }

                                title={
                                    <div className={classes.divHeaderTitle}>
                                        {fastTagStatus == "transfer_failed" &&
                                            <>
                                                Transfer Failed
                                            </>
                                        }
                                        {fastTagStatus == "transfer_pending" &&
                                            <>
                                                Transfer Pending
                                            </>
                                        }
                                    </div>
                                }
                                classes={{ root: classes.cardHeaderRoot, avatar: classes.cardAvatar }}
                                className={fastTagStatus == "transfer_failed" ? classes.rechargeFailedHeader : classes.rechargePendingHeader}
                            />
                        }

                        {headerType == "refund" &&
                            <CardHeader
                                avatar={
                                    <>
                                        {fastTagStatus == "refund_successful" &&
                                            <img src={RefundSuccessGreen} className={classes.imgV2} />
                                        }
                                        {fastTagStatus == "refund_initiated" &&
                                            <img src={RefundPendingOrange} className={classes.imgV2} />
                                        }
                                    </>
                                }

                                title={
                                    <div className={classes.divHeaderTitle}>
                                        {fastTagStatus == "refund_successful" &&
                                            <>
                                                Refund Successful
                                            </>
                                        }
                                        {fastTagStatus == "refund_initiated" &&
                                            <>
                                                Refund Initiated
                                            </>
                                        }
                                    </div>
                                }
                                classes={{ root: classes.cardHeaderRoot, avatar: classes.cardAvatar }}
                                className={fastTagStatus == "refund_successful" ? classes.rechargeSuccessHeader : classes.rechargePendingHeader}
                            />
                        }


                        {/* ********************************************************************************************************. */}


                        <CardContent className={classes.cardContent} >

                            {/* ********************************* 1st Row ************************************ */}
                            <Grid container justify="space-between" wrap="nowrap">
                                <Grid item>
                                    <div className={classes.titleV1}>Vehicle No</div>
                                    <div className={classes.textV3}>
                                        {fastTagRechargeInfo && fastTagRechargeInfo.vehicleNumberArray && fastTagRechargeInfo.vehicleNumberArray.map((truckNumber, index) => (
                                            <div className={(index == fastTagRechargeInfo.vehicleNumberArray.length - 1) ? classes.mlV1 : ""}>{truckNumber}</div>
                                        ))}
                                    </div>
                                </Grid>
                                <Grid item>
                                    <div className={classes.titleV2}>
                                        {fastTagStatus == "transfer_failed" ?
                                            (
                                                <>
                                                    Payment Amount
                                                </>
                                            )
                                            :
                                            (
                                                <>
                                                    Payment Amount
                                                </>
                                            )
                                        }
                                    </div>
                                    <div className={fastTagStatus == "transfer_failed" ? classes.textLoss : classes.textV4}>{numberFormat(fastTagRechargeInfo && fastTagRechargeInfo.rechargeAmount ? fastTagRechargeInfo.rechargeAmount : 0)}</div>
                                </Grid>
                            </Grid>


                            {/* ********************************* 2nd Row ************************************ */}
                            <Grid container justify="space-between" wrap="nowrap" className={classes.mtV1}>
                                <Grid item>
                                    <div className={classes.titleV1}>Payment Date</div>
                                    <div className={classes.textV1}>{fastTagRechargeInfo && fastTagRechargeInfo.rechargeTime ? getDateInStringDDMMMYYYY(fastTagRechargeInfo.rechargeTime) : "--"}</div>
                                </Grid>
                                {/* <Grid item>
                                    <div className={classes.titleV2}>Order ID</div>
                                    <div className={classes.textV2}>{fastTagRechargeInfo && fastTagRechargeInfo.paymentUtr ? fastTagRechargeInfo.paymentUtr : "--"}</div>
                                </Grid> */}
                            </Grid>
                            {fastTagStatus == "recharge_successful" &&<FormControlLabel
                                control={<GreenCheckbox />}
                                className={classes.saveAsExpense}
                                checked={fastTagRechargeInfo && fastTagRechargeInfo.saveAsExpense?fastTagRechargeInfo.saveAsExpense:false}
                                onChange={(e, value) => {
                                    setConfirmDialog(true)
                                }}
                                name='saveAsExpense'
                                label="Mark this Recharge as Truck Expense "
                                labelPlacement="end"
                            />}
                        </CardContent>

                    </Card>
                    {fastTagRechargeInfo && <Paper className={classes.paymentToCard}>
                            <div className={classes.detailsDiv}>
                                <Typography className={classes.cardHeader}>Paid To</Typography>
                                <div className={classes.section}>
                                    <div className={classes.subTitleSec} >
                                        <Typography className={classes.subTitleTxt}>FASTag Account</Typography>
                                        <Typography className={classes.subTitleTxt}>Account Number</Typography>
                                    </div>
                                    <div className={classes.valueSec}>
                                        <Typography className={classes.valueTxt}>{fastTagRechargeInfo && fastTagRechargeInfo.bankName?fastTagRechargeInfo.bankName:"---"}</Typography>
                                        <Typography className={classes.valueTxt}>{fastTagRechargeInfo && fastTagRechargeInfo.accNumber?fastTagRechargeInfo.accNumber:"---"}</Typography>
                                    </div>
                                </div>
                                <div className={classes.section}>
                                    <div className={classes.subTitleSec} >
                                        <Typography className={classes.subTitleTxt}>Order ID</Typography>
                                    </div>
                                    <div className={classes.valueSec}>
                                        <Typography className={classes.valueTxt}>{fastTagRechargeInfo && fastTagRechargeInfo.orderId?fastTagRechargeInfo.orderId:"---"}</Typography>
                                    </div>
                                </div>
                            </div>
                    </Paper>}
                    {fastTagRechargeInfo.paymentMode && <Paper className={classes.paymentModeUsedCard}>
                            <div className={classes.detailsDiv}>
                                <Typography className={classes.cardHeader}>Paid Using</Typography>
                                <div className={classes.section}>
                                    <div className={classes.valueSec}>
                                        <Box component={'div'} display={'flex'} alignItems={'center'}>
                                            {getPaymentMode(fastTagRechargeInfo.paymentMode)}
                                            <Typography className={classes.modeValueTxt}>{fastTagRechargeInfo.paymentMode}</Typography>
                                        </Box>
                                        <Box component={'div'} display={'flex'} flexDirection={'column'} justifyContent={'end'}>
                                            <Typography className={classes.amount}>{fastTagRechargeInfo && fastTagRechargeInfo.rechargeAmount?numberFormat(fastTagRechargeInfo.rechargeAmount):"---"}</Typography>
                                        </Box>
                                    </div>
                                </div>
                            </div>
                    </Paper>}

                    {/* **************************************Transaction Timeline Card **************************************. */}
                    <Card className={fastTagStatus == "recharge_successful" ? classes.cardV3 : classes.cardV2}>

                        <Timeline className={classes.timeLineV1}>

                            {/* ******************************************** Transfer Status. ********************************************  */}
                            {fastTagStatus == "transfer_failed" &&
                                <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                                    <TimelineSeparator>
                                        <TimelineDot classes={{ root: classes.rootDotFailed }}>
                                            <img src={ErrorIconWhite} className={classes.imgV1} />
                                        </TimelineDot>
                                    </TimelineSeparator>
                                    <TimelineContent classes={{ root: classes.contentRootV1 }}>
                                        <div className={classes.titleV5}>Transfer Failed</div>
                                        <div className={classes.textV5}>{fastTagRechargeInfo && fastTagRechargeInfo.paymentTime ? getMilliDateInDayDateTime(fastTagRechargeInfo.paymentTime) : ""}</div>
                                    </TimelineContent>
                                </TimelineItem>
                            }

                            {fastTagStatus == "transfer_pending" &&
                                <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                                    <TimelineSeparator>
                                        <TimelineDot classes={{ root: classes.rootDotPending }}>
                                            <img src={PendingIconWhite} className={classes.imgV1} />
                                        </TimelineDot>
                                    </TimelineSeparator>
                                    <TimelineContent classes={{ root: classes.contentRootV1 }}>
                                        <div className={classes.titleV5}>Transfer Pending</div>
                                        <div className={classes.textV5}>{fastTagRechargeInfo && fastTagRechargeInfo.paymentTime ? getMilliDateInDayDateTime(fastTagRechargeInfo.paymentTime) : ""}</div>
                                    </TimelineContent>
                                </TimelineItem>
                            }

                            {(fastTagStatus == "recharge_successful" || fastTagStatus == "recharge_pending" || fastTagStatus == "refund_successful" || fastTagStatus == "refund_initiated") &&
                                <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                                    <TimelineSeparator>
                                        <TimelineDot classes={{ root: classes.rootDotSuccessful }}>
                                            &#8377;
                                        </TimelineDot>
                                        <TimelineConnector classes={{ root: (fastTagStatus == "recharge_pending" || fastTagStatus == "refund_successful" || fastTagStatus == "refund_initiated") ? classes.lineConnectorPending : classes.lineConnectorRoot }} />
                                    </TimelineSeparator>
                                    <TimelineContent classes={{ root: classes.contentRootV1 }}>
                                        <div className={classes.titleV5}>Transfer Successful</div>
                                        <div className={classes.textV5}>{fastTagRechargeInfo && fastTagRechargeInfo.paymentTime ? getMilliDateInDayDateTime(fastTagRechargeInfo.paymentTime) : "--"}</div>
                                    </TimelineContent>
                                </TimelineItem>
                            }

                            {/* **********************************************************************************************************. */}


                            {/* ******************************************** Recharge Status. ******************************************** */}
                            {fastTagStatus == "recharge_successful" &&
                                <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                                    <TimelineSeparator>
                                        <TimelineDot classes={{ root: classes.rootDotSuccessfulV1 }}>
                                            <img src={BankIcon} />
                                        </TimelineDot>
                                    </TimelineSeparator>
                                    <TimelineContent classes={{ root: classes.contentRootV1 }}>
                                        <div className={classes.titleV5}>Recharge Successful</div>
                                        <div className={classes.textV5}>{fastTagRechargeInfo && fastTagRechargeInfo.rechargeTime ? getMilliDateInDayDateTime(fastTagRechargeInfo.rechargeTime) : "--"}</div>
                                    </TimelineContent>
                                </TimelineItem>
                            }

                            {(fastTagStatus == "refund_successful" || fastTagStatus == "refund_initiated") &&
                                <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                                    <TimelineSeparator>
                                        <TimelineDot classes={{ root: classes.rootDotFailedV1 }}>
                                            <img src={ErrorIconRed} className={classes.imgV1} />
                                        </TimelineDot>
                                        <TimelineConnector classes={{ root: classes.lineConnectorPending }} />
                                    </TimelineSeparator>
                                    <TimelineContent classes={{ root: classes.contentRootV1 }}>
                                        <div className={classes.titleV5}>Recharge Failed</div>
                                        <div className={classes.textV5}>{fastTagRechargeInfo && fastTagRechargeInfo.rechargeTime ? getMilliDateInDayDateTime(fastTagRechargeInfo.rechargeTime) : "--"}</div>
                                    </TimelineContent>
                                </TimelineItem>
                            }

                            {fastTagStatus == "recharge_pending" &&
                                <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                                    <TimelineSeparator>
                                        <TimelineDot classes={{ root: classes.rootDotPendingV1 }}>
                                            <img src={BankIconOrange} />
                                        </TimelineDot>
                                        {/* <TimelineConnector classes={{ root: classes.lineConnectorRoot }} /> */}
                                    </TimelineSeparator>
                                    <TimelineContent classes={{ root: classes.contentRootV1 }}>
                                        <div className={classes.titleV5}>Waiting for your Bank to Confirm</div>
                                        {/* <div className={classes.textV6}>We are trying to complete the recharge
                                            with your fastag bank and we will notify
                                            you, once the recharge is sucessful.</div> */}
                                        <div className={classes.textV6}>This might take upto 2 hours. We will notify you when the Recharge is successful.</div>
                                    </TimelineContent>
                                </TimelineItem>
                            }
                            {/* **********************************************************************************************************. */}


                            {/* ******************************************** Refund Status. ******************************************** */}
                            {fastTagStatus == "refund_successful" &&
                                <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                                    <TimelineSeparator>
                                        <TimelineDot classes={{ root: classes.rootDotSuccessfulV1 }}>
                                            <img src={RefundSuccessWhite} />
                                        </TimelineDot>
                                    </TimelineSeparator>
                                    <TimelineContent classes={{ root: classes.contentRootV1 }}>
                                        <div className={classes.titleV5}>Refund Successful</div>
                                        <div className={classes.textV5}>{fastTagRechargeInfo && fastTagRechargeInfo.refundTime ? getMilliDateInDayDateTime(fastTagRechargeInfo.refundTime) : "--"}</div>
                                    </TimelineContent>
                                </TimelineItem>
                            }

                            {fastTagStatus == "refund_initiated" &&
                                <TimelineItem classes={{ root: classes.timeLineItemRoot, missingOppositeContent: classes.missingOppositeContentV1 }}>
                                    <TimelineSeparator>
                                        <TimelineDot classes={{ root: classes.rootDotPendingV1 }}>
                                            <img src={RefundPendingOrange} />
                                        </TimelineDot>
                                    </TimelineSeparator>
                                    <TimelineContent classes={{ root: classes.contentRootV1 }}>
                                        <div className={classes.titleV5}>Refund initiated</div>
                                        <div className={classes.textV5}>{fastTagRechargeInfo && fastTagRechargeInfo.refundTime ? getMilliDateInDayDateTime(fastTagRechargeInfo.refundTime) : "--"}</div>
                                    </TimelineContent>
                                </TimelineItem>
                            }
                            {/* **********************************************************************************************************. */}


                        </Timeline>

                    </Card>

                </SideBarDialogContent>



                <SideBarDialogActions className={classes.sideBarActions} >

                    <div>
                        <Button variant="contained" className={classes.closeButton} onClick={handleClose} >
                            Close
                        </Button>
                        {/* {fastTagStatus == "recharge_successful" &&
                            <Button variant="contained" className={classes.rechargeButton} onClick={(e) => handleRechargeAgain(e)}>
                                Recharge Again
                            </Button>
                        } */}
                    </div>

                </SideBarDialogActions>
            </Drawer>
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={confirmDialog} onClose={handleConfirmDialogClose}
            >
                <DialogContent>
                    <div style={{marginBottom:16}} className={fastTagRechargeInfo && fastTagRechargeInfo.saveAsExpense?classes.red:classes.blue}>{fastTagRechargeInfo && fastTagRechargeInfo.saveAsExpense?"Remove From Expense":"Mark As Expense"}</div>
                    <div className={classes.mtV5}>Do you want to {fastTagRechargeInfo && fastTagRechargeInfo.saveAsExpense?"Remove":"Mark"} this recharge as Truck Expense</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmDialogClose}>
                        <span className={classes.cancelV1}>
                            No
                        </span>
                    </Button>
                    <Button onClick={onConfirm}>
                        <span className={fastTagRechargeInfo && fastTagRechargeInfo.saveAsExpense?classes.red:classes.blue}>
                            YES
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchEditFastagExpense: (id,data, onSuccess, onError) => {
        dispatch(EditFastagExpense(id,data, onSuccess, onError))
    },
    dispatchGetFastTagRechargeStatus: (transactionId, onSuccess, onFailure) => {
        dispatch(getFastTagRechargeStatus(transactionId, onSuccess, onFailure))
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FastTagTransactDetailsSideBar);
